export const appInfo = {
  version: 'v_1.4',
  environment: 'Staging',
  database: 'Staging',
  lastUpdated: '18:10 IST, 30 Dec 2025'
};

export default appInfo;
